import Vue from "vue";
import axios from "axios";
import _ from "lodash";
import ProductReviewBlock from "@/Reviews/ProductReviewBlock.vue";
import { Review } from "@/Reviews";
import * as ReviewsData from "@/Reviews/fixtures";
import { Products, Product } from "@/ProductPage/ProductPageStateSchema";
import { TPReviews } from "./fixtures";

function getDisplayedReview(products: Products): Review {
  return getReviewsIOProductReview(products) ?? _.sample(TPReviews);
}

function getReviewsIOProductReview(products: Products): Review | undefined {
  const codes = [
    ...new Set(
      Array.from(products.products.values())
        .map(buildProductCodes)
        .reduce((accumulator, codes) => accumulator.concat(codes), [])
    ),
  ];

  return codes.map((code) => ReviewsData.RIOProductReviews[code]).find((review) => review);
}

function buildProductCodes(product: Product): string[] {
  return Array.from(product.strengths.keys()).reduce((accumulator, strengthCode) => {
    let code: string = product.code;
    switch (product.actionButtonType) {
      case "DEFAULT":
      case "FIXED_STRENGTH":
        code = code.concat(strengthCode);
        break;
      case "FIXED_NO_STRENGTH":
      default:
        break;
    }

    return accumulator.concat(code);
  }, []);
}

export function bindProductReviewBlock(products: Products): void {
  const mountingElement = document.getElementById("product-review-block");

  if (!mountingElement) {
    return;
  }

  const dimensions = (mountingElement as HTMLElement).dataset.dimensions;

  const selector = "#trust-pilot-params";
  const paramsElement = document.querySelector(selector);

  if (!paramsElement) {
    console.error(`Cannot find parameters for trustpilot using selector ${selector}`);
    return;
  }

  const jsonData = JSON.parse(paramsElement.innerHTML);

  new Vue({
    el: mountingElement,
    data: {
      trustPilotScore: 4.7,
      topReview: getDisplayedReview(products),
    },
    render: function (createElement) {
      return createElement(ProductReviewBlock, {
        props: { trustPilotScore: this.trustPilotScore, topReview: this.topReview, dimensions, ...jsonData },
      });
    },
    mounted: async function onMounted() {
      await axios
        .get("/api/company-reviews")
        .then((response) => {
          const { trustPilotCompanyScore } = response.data;

          this.trustPilotScore = trustPilotCompanyScore;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  });
}
